import { usePrompt } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { Module } from '@/modules/companies/consts'
import React from 'react'
import styled from 'styled-components'
import { useVehicleExpirationTypeMutations } from '../../../vehicles/fleet/mutations.hooks'
import type { VehicleExpirationTypeForm } from '../components'
import { OldAddButton, InfoBox, SettingsWrapper } from '../components'
import { AddVehicleExpirationTypeModal } from '../components/AddVehicleExpirationTypeModal'
import { ModuleResponsibleUsers } from '../components/ModuleResponsibleUsers'

const StyledAddCategoryNameBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

interface VehicleFleetSettingsProps {}

export const VehicleFleetSettings: React.FC<VehicleFleetSettingsProps> = () => {
  const translations = useTranslate({
    info: 'settings.info.vehicles',
    type: 'form.type-material',
    createForm: 'common.create-form',
    create: 'common.create-alt',
    editForm: 'form.edit-form',
    close: 'common.close',
    addExpirationType: 'settings.add-vehicle-expiration-type',
  })
  const addPrompt = usePrompt()
  const { createVehicleExpirationType } = useVehicleExpirationTypeMutations()

  const handleCreate = async () => {
    const { data } = await addPrompt<VehicleExpirationTypeForm | null>(
      resolve => <AddVehicleExpirationTypeModal onSubmit={resolve} />
    )

    if (!data) return

    await createVehicleExpirationType({
      variables: {
        input: {
          name: data.categoryName,
        },
      },
    })
  }

  return (
    <SettingsWrapper grid={{ flow: 'row' }}>
      <InfoBox>
        <p>{translations.info}</p>
      </InfoBox>

      <ModuleResponsibleUsers module={Module.VEHICLES} />

      <StyledAddCategoryNameBlock>
        <OldAddButton
          addText={translations.addExpirationType}
          adding={false}
          onClick={handleCreate}
        />
      </StyledAddCategoryNameBlock>
    </SettingsWrapper>
  )
}
